import type { GetOfferV1Response as BmOffer } from '@backmarket/nuxt-layer-buyback/app/scopes/offer/api/types'

import type { Offer as ApacOffer } from '~/api/tradein-apac/types'

/**
 * Adapt a trade-in offer in APAC format to BM format.
 *
 * The result can be passed to 'useBuybackOffer' which supports persistence and used to display the
 * trade-in offer in many pages (PDP, Product Cards, cart, etc).
 *
 * Not all data are properly mapped in BM format. There is an improvement, follow-up, task to improve it.
 * https://backmarket.atlassian.net/browse/APAC-1319
 */
export function apacToBmOffer(offer: ApacOffer): BmOffer {
  return {
    product: {
      fullTitle: offer.productShortTitle,
      image: offer.productImage || '',
      productId: '',
      shortTitle: offer.productShortTitle,
    },
    listing: {
      price: offer.price,
      listingPublicId: '',
    },
    instructions: [],
    checkup: [],
    shipping: {
      hasChoice: false,
      default: 'SELF_PACKAGED',
    },
    bankDetailsRequired: false,
    tier: 'medium',
    grade: 'FUNCTIONAL_FLAWLESS',
    funnelSummary: [],
    rawCheckup: {
      estheticCondition: null,
      screenCondition: null,
      casingCondition: null,
      workingCondition: null,
      batteryCondition: null,
    },
    extra: {
      partnerOfferUrl: offer.partnerOfferUrl,
      externalId: offer.externalId,
    },
  }
}

/**
 * Adapt a trade-in offer in BM format to APAC format.
 */
export function bmToApacOffer(offer: BmOffer): ApacOffer {
  const partnerOfferUrl =
    typeof offer.extra?.partnerOfferUrl === 'string'
      ? offer.extra.partnerOfferUrl
      : ''
  const externalId =
    typeof offer.extra?.externalId === 'string'
      ? offer.extra.externalId
      : undefined
  return {
    price: offer.listing.price,
    productShortTitle: offer.product.shortTitle,
    productImage: offer.product.image || undefined,
    partnerOfferUrl,
    externalId,
  }
}
